import API from '@/lib/API.js'
import comun from './comun.js'
const conveniosprestacionales = {
  namespaced: true,
  state: {
    Lista: [],
    Seleccionado: undefined
  },
  mutations: {
    init(state){
      state.Seleccionado = undefined
    },
    set(state, payload) {
      state.Lista = payload;
    },
    select(state, payload) {
      state.Seleccionado = payload;
    },
  },
  actions: {
    async set({
      commit,
      state
    }) {
      if (state.Lista.length === 0) {
        commit("comun/cargando")
        let data = await API.Convenios_Prestacionales.traerTodos();
        commit("set", data)
        commit("comun/fincarga")
      }
    },
    async FiltrarPorDescripcion({
      commit
    }, payload) {
      commit("comun/cargando")
      let data = []
      data = await API.Convenios_Prestacionales.traerPorDescripcion(payload);
      commit("set", data)
      commit("comun/fincarga")
    },
    select({
      commit
    }, payload) {
      commit("select", payload)
      commit("set", [])
    },
    async modificarSeleccionado({
      commit,
      state
    }) {
      try {
        let data = []
        let str = ""
        if (state.Seleccionado.id_convenio != 0) {
          data = await API.Convenios_Prestacionales.modificar(state.Seleccionado);
          str += "Convenio modificado"
        } else {
          data = await API.Convenios_Prestacionales.alta(state.Seleccionado);
          str += `Nuevo Convenio de alta '${data.denominacion}'`
        }
        commit("select", data)
        commit("comun/mostrar", str)

      } catch (error) {
        alert(error)
      }
    },
  },
  modules: {
    comun,
  }

}
export default conveniosprestacionales;